module.exports = {
      id: "video--mfdW9-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "static/sprites.6bfdee46477d1df1130464f2fb5e7e66.svg#video--mfdW9-usage",
      toString: function () {
        return this.url;
      }
    }